import Vue from "vue";
import Vuex from "vuex";
import messages from "../languages";

const lang = localStorage.getItem("language") ?? "pt";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // On maintanance
    counterOfErrors500: 0,

    fetchBetsUserRetail: false,
    fetchCreditsUserRetail: false,

    // ====================================================
    // Info Table
    sports: [],
    markets: [],
    outcomes: [],
    // ====================================================
    // General
    betCard: "",
    betDialog: false,
    feedbackSnack: "",
    feedbackDialog: "",
    feedbackProgress: false,
    operator: {},
    url: "",
    showDialog: false,
    // Events Adm Reports Dialogs
    showDialogEditOdds: false,
    showDialogBetPlacedReport: false,
    showDialogAllMarketsReport: false,

    refreshPromotions: false,

    drawerProfile: {
      open: false,
      data: {
        dados: {
          nome: "",
          login: ""
        }
      }
    },
    vuexFilterDataRange: {},
    vuexFilterDays: 30,
    rangeUI: "",
    refresh: false,
    fullscreen: false,
    actionConfirm: false,
    updateListBalance: "",
    mainContainerFluid: false,
    depositPix: {
      status: false,
      value: "",
      imgQrcode: "",
      codeQr: ""
    },
    casinoCategoriesList: [],
    // ====================================================
    // RangeDate
    range: {
      enable: false,
      select: "",
      date: {
        data_inicio: "",
        data_final: ""
      },
      date_start_br: "",
      date_end_br: "",
      time_start: "",
      time_end: "",
      disabled: false
    },
    // ====================================================
    // Filters State Default
    filters: {
      enableWrap: false,
      save: false,
      disabledSave: false,
      autocompleteRegionals: {
        enable: false,
        id: ""
      },
      autocompleteLocals: {
        enable: false,
        id: ""
      },
      autocompleteAgents: {
        enable: false,
        id: ""
      },
      autocompletePlayers: {
        enable: false,
        id: ""
      },
      linkedExemptPlayer: {
        alreadyLinked: false,
        id: "",
        name: "",
      },
      autocompleteProvidersByOperator: {
        enable: false,
        id: "",
        stringId: ""
      },
      autocompleteCasinoCategories: {
        enable: false,
        name: ""
      },
      autocompleteCollectors: {
        enable: false,
        id: ""
      },
      autocompleteRoutes: {
        enable: false,
        id: ""
      },
      selectStatus: {
        enable: false,
        status: 1
      },
      selectCasinoLobby: {
        enable: false,
        value: 0 // 0 cassino normal, 1 cassino live e "" todos na rota do listCategories
      },
      selectCasinoTheme: {
        enable: false,
        value: "" // 0 cassino normal, 1 cassino live
      },
      selectCasinoVerticalCategory: {
        enable: false,
        value: "" // 0 cassino normal, 1 cassino live
      },
      selectStatusBet: {
        enable: false,
        status: 1 // ativas 1, canceladas 0
      },
      selectTypeBet: {
        enable: false,
        type: "deposit" // Depósitos: deposit, Bônus: bonus
      },
      selectTypeBetCasino: {
        enable: false,
        type: 0, // 0 apostas válidas, 1 apostas isentas
      },
      selectStatusEvents: {
        enable: false,
        status: 1 // Ativos 1, Cancelados 2, Adiados 3, Suspendidos 4;
      },
      eventNumber: {
        enable: false,
        value: ""
      },
      selectResultBet: {
        enable: false,
        result: 3 // Pendentes 3, Perdidas 0, Premiadas 1, Todas 4
      },
      selectCasinoGroupBy: {
        enable: false,
        value: "" // Jogo "jogo" => CasinoListBetOnline "game", Tipo de Jogo "tipo", Provedor "provedor" => CasinoListBetOnline "provider"
      },
      selectFinancialCategoryAgent: {
        enable: false,
        category: 3 // 1 - Recebeu do Agente; 2 - Depositou no Agente; 3 - Todos;
      },
      sinal: {
        enable: false,
        option: "", // Exatamente, maior, menor
        valor: "" // Decimal com ponto
      },
      groupStatus: {
        enable: false,
        status: 1 // 0 cancelado, 1 ativo;
      },
      groupOriginBet: {
        enable: false,
        value: "todos" // 'terminal', 'agentes', 'todos';
      },
      groupExport: {
        enable: false,
        value: "" // Site  '', Excel 1;
      },
      groupTypeLive: {
        enable: false,
        value: "" // Geral: "", "Live";
      },
      quantityBet: {
        enable: false,
        value: 10
      },
      selectTypeBankStatement: {
        enable: false,
        value: 1 // Status Saques e depósitos
      },
      selectUserLogLevel: {
        enable: false,
        value: "backoffice" // backoffice, agent, player
      },
      selectActionLog: {
        enable: false,
        value: "" // vários
      },
      inputStringLog: {
        enable: false,
        value: "" // string
      },
      selectStatusPlayers: {
        enable: false,
        status: "" // Status Saques e depósitos
      },
      TabsNavigationButtons: {
        enable: false,
        route: ""
      },
      sinalDeposit: {
        enable: false,
        option: "", // Exatamente, maior, menor
        valor: "" // Decimal com ponto
      },
      sinalAward: {
        enable: false,
        option: "", // Exatamente, maior, menor
        valor: "" // Decimal com ponto
      },
      selectEventStage: {
        enable: false,
        value: "prematch" // prematch, daymatch, both, live
      },
      depositValue: {
        enable: false,
        option: "",
        value: ""
      },
      selectSport: {
        enable: false,
        text: "",
        value: ""
      },
      paymentProvider: {
        enable: false,
        text: messages[lang].all,
        value: "all"
      },
      gamingType: {
        enable: false,
        text: messages[lang].all,
        value: "all"
      },
      bonusReportType: {
        enable: false,
        text: messages[lang].all,
        value: "all"
      },
      paymentMonth: {
        enable: false,
        text: "",
        value: (() => {
          let d = new Date(new Date().setMonth(new Date().getMonth() - 1));
          return new Date(d - d.getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 7);
        })()
      },
      hasInvoice: {
        enable: false,
        text: "",
        value: ""
      },
    },
    // ====================================================
    // List Users
    listUsersRegionals: [],
    listUsersLocals: [],
    listUsersAgents: [],
    listCollectors: [],

    massUpdateDialog: false,
    payBet: false,

    notificationCounter: 0,

    dialogActivateOrDesactivateCampaign: {
      status: false,
      idCampaign: "",
      nameCampaign: "",
      isActivate: false,
    },
  },
  mutations: {
    // ====================================================
    // Info Table
    markets(state, data) {
      state.markets = data;
    },
    outcomes(state, data) {
      state.outcomes = data;
    },
    sports(state, data) {
      state.sports = data;
    },
    // ====================================================
    // General
    updateListBalance(state, data) {
      state.updateListBalance = data;
    },
    setFeedbackDialog(state, data) {
      state.feedbackDialog = data;
    },
    setFeedbackSnack(state, data) {
      state.feedbackSnack = data;
    },
    setFeedbackProgress(state, data) {
      state.feedbackProgress = data;
    },
    setBetCard(state, data) {
      state.betCard = data;
    },
    showDialog(state, data) {
      state.showDialog = data;
    },
    showBetDialog(state, data) {
      state.betDialog = data;
    },
    showDrawerProfile(state, data) {
      state.drawerProfile = data;
    },
    vuexFilterDataRange(state, data) {
      state.vuexFilterDataRange = data;
    },
    vuexFilterDays(state, data) {
      state.vuexFilterDays = data;
    },
    setRefresh(state, data) {
      state.refresh = data;
    },
    setFullscreen(state, data) {
      state.fullscreen = data;
    },
    setActionConfirm(state, data) {
      state.actionConfirm = data;
    },
    mainContainerFluid(state, bool) {
      state.mainContainerFluid = bool;
    },
    setOperator(state, obj) {
      state.operator = obj;
    },
    setCasinoCategoriesList(state, data) {
      state.casinoCategoriesList = data;
    },
    // ====================================================
    // Range
    Range(state, bool) {
      state.range.enable = bool;
    },
    SetRangeDate(state, object) {
      // format: "2021-02-05T00:00:00.399" (ISO)
      state.range.date = object;
    },
    SetRangeSelect(state, object) {
      // format obj: {label: "",value: "",}
      state.range.select = object;
    },
    SetDateStartBr(state, string) {
      state.range.date_start_br = string;
    },
    SetDateEndBr(state, string) {
      state.range.date_end_br = string;
    },
    SetTimeStart(state, string) {
      state.range.time_start = string;
    },
    SetTimeEnd(state, string) {
      state.range.time_end = string;
    },
    setDisabledRange(state, bool) {
      state.range.disabled = bool;
    },
    setRangeUI(state, data) {
      state.rangeUI = data;
    },
    // ====================================================
    // Filters: Enable
    FiltersWrap(state, bool) {
      state.filters.enableWrap = bool;
    },
    AutocompleteRegionals(state, bool) {
      state.filters.autocompleteRegionals.enable = bool;
    },
    AutocompleteLocals(state, bool) {
      state.filters.autocompleteLocals.enable = bool;
    },
    AutocompleteAgents(state, bool) {
      state.filters.autocompleteAgents.enable = bool;
    },
    AutocompletePlayers(state, bool) {
      state.filters.autocompletePlayers.enable = bool;
    },
    AutocompleteProvidersByOperator(state, bool) {
      state.filters.autocompleteProvidersByOperator.enable = bool;
    },
    AutocompleteCasinoCategories(state, bool) {
      state.filters.autocompleteCasinoCategories.enable = bool;
    },
    AutocompleteCollectors(state, bool) {
      state.filters.autocompleteCollectors.enable = bool;
    },
    AutocompleteRoutes(state, bool) {
      state.filters.autocompleteRoutes.enable = bool;
    },
    SelectStatus(state, bool) {
      state.filters.selectStatus.enable = bool;
    },
    SelectCasinoLobby(state, bool) {
      state.filters.selectCasinoLobby.enable = bool;
    },
    SelectCasinoTheme(state, bool) {
      state.filters.selectCasinoTheme.enable = bool;
    },
    SelectCasinoVerticalCategory(state, bool) {
      state.filters.selectCasinoVerticalCategory.enable = bool;
    },
    SelectResultBet(state, bool) {
      state.filters.selectResultBet.enable = bool;
    },
    SelectCasinoGroupBy(state, bool) {
      state.filters.selectCasinoGroupBy.enable = bool;
    },
    SelectStatusBet(state, bool) {
      state.filters.selectStatusBet.enable = bool;
    },
    SelectEventStage(state, bool) {
      state.filters.selectEventStage.enable = bool;
    },
    SelectTypeBet(state, bool) {
      state.filters.selectTypeBet.enable = bool;
    },
    SelectTypeBetCasino(state, bool) {
      state.filters.selectTypeBetCasino.enable = bool;
    },
    SelectStatusEvents(state, bool) {
      state.filters.selectStatusEvents.enable = bool;
    },
    SelectFinancialCategoryAgent(state, bool) {
      state.filters.selectFinancialCategoryAgent.enable = bool;
    },
    Sinal(state, bool) {
      state.filters.sinal.enable = bool;
    },
    GroupStatus(state, bool) {
      state.filters.groupStatus.enable = bool;
    },
    GroupOriginBet(state, bool) {
      state.filters.groupOriginBet.enable = bool;
    },
    GroupExport(state, bool) {
      state.filters.groupExport.enable = bool;
    },
    GroupTypeLive(state, bool) {
      state.filters.groupTypeLive.enable = bool;
    },
    QuantityBet(state, bool) {
      state.filters.quantityBet.enable = bool;
    },
    SelectTypeBankStatement(state, bool) {
      state.filters.selectTypeBankStatement.enable = bool;
    },
    SelectUserLogLevel(state, bool) {
      state.filters.selectUserLogLevel.enable = bool;
    },
    SelectActionLog(state, bool) {
      state.filters.selectActionLog.enable = bool;
    },
    InputStringLog(state, bool) {
      state.filters.inputStringLog.enable = bool;
    },
    SelectStatusPlayers(state, bool) {
      state.filters.selectStatusPlayers.enable = bool;
    },
    TabsNavigationButtons(state, bool) {
      state.filters.TabsNavigationButtons.enable = bool;
    },
    DisabledSave(state, bool) {
      state.filters.disabledSave = bool;
    },
    SinalDeposit(state, bool) {
      state.filters.sinalDeposit.enable = bool;
    },
    SinalAward(state, bool) {
      state.filters.sinalAward.enable = bool;
    },
    EventNumber(state, bool) {
      state.filters.eventNumber.enable = bool;
    },
    // Filters: Set data
    setSave(state, bool) {
      state.filters.save = bool;
    },
    setRegionalId(state, regionalId) {
      state.filters.autocompleteRegionals.id = regionalId;
    },
    setLocalId(state, localsId) {
      state.filters.autocompleteLocals.id = localsId;
    },
    setAgentId(state, agentId) {
      state.filters.autocompleteAgents.id = agentId;
    },
    setPlayerId(state, playerId) {
      state.filters.autocompletePlayers.id = playerId;
    },
    setLinkedExemptPlayer(state, { alreadyLinked, id, name }) {
      state.filters.linkedExemptPlayer = { alreadyLinked, id, name };
    },
    setProviderId(state, provider) {
      state.filters.autocompleteProvidersByOperator.id = provider.id;
      state.filters.autocompleteProvidersByOperator.stringId =
        provider.provider_id;
    },
    setCasinoCategoryName(state, casinoCategoryName) {
      state.filters.autocompleteCasinoCategories.name = casinoCategoryName;
    },
    setCollectorId(state, collectorId) {
      state.filters.autocompleteCollectors.id = collectorId;
    },
    setRouteId(state, routeId) {
      state.filters.autocompleteRoutes.id = routeId;
    },
    setSelectStatus(state, status) {
      state.filters.selectStatus.status = status;
    },
    setSelectCasinoLobby(state, value) {
      state.filters.selectCasinoLobby.value = value;
    },
    setSelectCasinoTheme(state, value) {
      state.filters.selectCasinoTheme.value = value;
    },
    setSelectCasinoVerticalCategory(state, value) {
      state.filters.selectCasinoVerticalCategory.value = value;
    },
    setSelectStatusBet(state, status) {
      state.filters.selectStatusBet.status = status;
    },
    setSelectEventStage(state, value) {
      state.filters.selectEventStage.value = value;
    },
    setSelectTypeBet(state, type) {
      state.filters.selectTypeBet.type = type;
    },
    setSelectTypeBetCasino(state, type) {
      state.filters.selectTypeBetCasino.type = type;
    },
    setSelectStatusEvents(state, status) {
      state.filters.selectStatusEvents.status = status;
    },
    setSelectResultBet(state, result) {
      state.filters.selectResultBet.result = result;
    },
    setSelectCasinoGroupBy(state, value) {
      state.filters.selectCasinoGroupBy.value = value;
    },
    setSelectFinancialCategoryAgent(state, category) {
      state.filters.selectFinancialCategoryAgent.category = category;
    },
    setSinal(state, object) {
      state.filters.sinal.option = object.option;
      state.filters.sinal.valor = object.valor;
    },
    setGroupStatus(state, status) {
      state.filters.groupStatus.status = status;
    },
    setGroupOriginBetValue(state, value) {
      state.filters.groupOriginBet.value = value;
    },
    setGroupExport(state, value) {
      state.filters.groupExport.value = value;
    },
    setGroupTypeLive(state, string) {
      state.filters.groupTypeLive.value = string;
    },
    setQuantityBet(state, value) {
      state.filters.quantityBet.value = value;
    },
    setSelectTypeBankStatement(state, value) {
      state.filters.selectTypeBankStatement.value = value;
    },
    setSelectUserLogLevel(state, value) {
      state.filters.selectUserLogLevel.value = value;
    },
    setSelectActionLog(state, value) {
      state.filters.selectActionLog.value = value;
    },
    setInputStringLog(state, str) {
      state.filters.inputStringLog.value = str;
    },
    setSelectStatusPlayers(state, status) {
      state.filters.selectStatusPlayers.status = status;
    },
    setRoute(state, route) {
      state.filters.TabsNavigationButtons.route = route;
    },
    setSinalDeposit(state, object) {
      state.filters.sinalDeposit.option = object.option;
      state.filters.sinalDeposit.valor = object.valor;
    },
    setSinalAward(state, object) {
      state.filters.sinalAward.option = object.option;
      state.filters.sinalAward.valor = object.valor;
    },
    setEventNumber(state, number) {
      if (number == "" || !isNaN(parseInt(number))) {
        state.filters.eventNumber.value = number;
      }
    },

    dialogDepositPix(state, obj) {
      state.depositPix = obj;
    },
    showDialogEditOdds(state, bool) {
      state.showDialogEditOdds = bool;
    },
    showDialogBetPlacedReport(state, bool) {
      state.showDialogBetPlacedReport = bool;
    },
    showDialogAllMarketsReport(state, bool) {
      state.showDialogAllMarketsReport = bool;
    },

    setRefreshPromotions(state, bool) {
      state.refreshPromotions = bool;
    },
    setUrl(state, url) {
      state.url = url;
    },

    // ====================================================
    // List Users
    listUsersRegionals(state, value) {
      state.listUsersRegionals = value;
    },
    listUsersLocals(state, value) {
      state.listUsersLocals = value;
    },
    listCollectors(state, value) {
      state.listCollectors = value;
    },
    listUsersAgents(state, value) {
      state.listUsersAgents = value;
    },
    massUpdateDialog(state, bool) {
      state.massUpdateDialog = bool;
    },
    setFetchBetsUserRetail(state, bool) {
      state.fetchBetsUserRetail = bool;
    },
    setFetchCreditsUserRetail(state, bool) {
      state.fetchCreditsUserRetail = bool;
    },
    setCounterOfErrors500(state) {
      state.counterOfErrors500 += 1;
    },
    resetCounterOfErrors500(state) {
      state.counterOfErrors500 = 0;
    },

    DepositValue(state, enable) {
      state.filters.depositValue.enable = enable;
    },
    setDepositValue(state, obj) {
      state.filters.depositValue = { ...state.filters.depositValue, ...obj };
    },

    SelectSport(state, enable) {
      state.filters.selectSport.enable = enable;
    },
    setSelectSport(state, obj) {
      state.filters.selectSport = { ...state.filters.selectSport, ...obj };
    },
    PaymentProvider(state, enable) {
      state.filters.paymentProvider.enable = enable;
    },
    setPaymentProvider(state, provider) {
      state.filters.paymentProvider = {
        ...state.filters.paymentProvider,
        ...provider
      };
    },
    setOperatorPaymentMethods(state, methods) {
      state.operator.payment_methods = methods;
    },
    GamingType(state, enable) {
      state.filters.gamingType.enable = enable;
    },
    setGamingType(state, gamingType) {
      state.filters.gamingType = {
        ...state.filters.gamingType,
        ...gamingType
      };
    },
    BonusReportType(state, enable) {
      state.filters.bonusReportType.enable = enable;
    },
    setBonusReportType(state, type) {
      state.filters.bonusReportType = {
        ...state.filters.bonusReportType,
        ...type,
      };
    },
    PaymentMonth(state, enable) {
      state.filters.paymentMonth.enable = enable;
    },
    setPaymentMonth(state, paymentMonth) {
      state.filters.paymentMonth = {
        ...state.filters.paymentMonth,
        ...paymentMonth
      };
    },
    disablePaymentMonth(state) {
      state.filters.paymentMonth.disabled = true;
    },
    enablePaymentMonth(state) {
      state.filters.paymentMonth.disabled = false;
    },
    HasInvoice(state, enable) {
      state.filters.hasInvoice.enable = enable;
    },
    setHasInvoice(state, hasInvoice) {
      state.filters.hasInvoice = {
        ...state.filters.hasInvoice,
        ...hasInvoice
      };
    },
    setVerifyBank(state, verify_bank) {
      state.operator.verify_bank = verify_bank;
    },
    payingBet(state, payBet) {
      state.payBet = payBet;
    },
    setMainEvents(state, main_events) {
      state.operator.main_events = main_events;
    },
    setNotificationCounter(state, value) {
      state.notificationCounter = value;
    },
    minusOneNotification(state) {
      state.notificationCounter--;
    },
    updateOperatorDepositBondConfiguration(state, enableDepositBond) {
      state.operator.deposit_bond = enableDepositBond;
    },
    setDialogActivateOrDesactivateCampaign(state, obj) {
      state.dialogActivateOrDesactivateCampaign = obj;
    },
  },
  getters: {
    getCounterOfErrors500: ({ counterOfErrors500 }) => counterOfErrors500,
    getFetchBetsUserRetail: ({ fetchBetsUserRetail }) => fetchBetsUserRetail,
    getFetchCreditsUserRetail: ({ fetchCreditsUserRetail }) =>
      fetchCreditsUserRetail,
    getFilterDataRange: state => {
      return state.vuexFilterDataRange;
    },
    getRefresh: state => {
      return state.refresh;
    },
    getMonthAndYearOfPayment: state => {
      const monthAndYear = state.filters.paymentMonth.value;
      const year = monthAndYear.substr(0, 4);
      const month = monthAndYear.substr(5, 6);
      return { year, month };
    },
    getDialogActivateOrDesactivateCampaign(state) {
      return state.dialogActivateOrDesactivateCampaign;
    }
  },
  actions: {},
  modules: {}
});
